import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PMVAuthenticationService, NavigationService } from 'pmv-common';
import { AppConfig } from '../app.config';

/**
 * Guarda de proteção das rotas internas do sistema. Só permite o acesso às rotas caso o usuário esteja autenticado no
 * sistema.
 */
@Injectable()
export class CandidatoLogadoGuard implements CanActivateChild {

  constructor(
    private authenticationService: PMVAuthenticationService,
    private router: Router,
    private navigationService: NavigationService,
    public appConfig: AppConfig,
  ) { }

  /**
   * Determina se o usuário pode acessar a próxima rota ou não, dependendo do estado de sua autenticação no sistema.
   *
   * @param next próxima rota a ser ativada ou não
   * @param state estado da rota corrente
   * @return true caso o a rota possa ser ativada e false caso contrário
   */
  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const estaLogado = this.authenticationService.isUserLoggedIn();

    if (!estaLogado) {
      this.redirectToLogin();
      return false;
    } else {
      const type = this.authenticationService.getTypeLoged();
      if (type === 1) {
        this.navigationService.setNavItems(this.appConfig.navItems); //CANDIDATO
        return true;
      } else {
        this.navigationService.setNavItems(this.appConfig.navItemsIntranet); //SERVIDOR
        return true;
      }
    }
  }

  redirectToLogin() {
    this.router.navigate(['login']);
  }
}


// WEBPACK FOOTER //
// ./src/app/authentication/candidatoLogadoGuard.guard.ts